
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/one-pager-asset-template-page",
      function () {
        return require("private-next-pages/generated-templates/one-pager-asset-template-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generated-templates/one-pager-asset-template-page"])
      });
    }
  